const menuTypes = {
  ROUTER_LINK: 'router-link',
  MENU_GROUPER: 'menu-grouper',
  SEPARATOR: 'separator',
};

export default menuTypes;
